import Blue from '~/core'

new Blue({
  name: 'Rate Table',
  selector: '.rate-table',
  setup(container) {
    const btn = container.querySelector('.rate-table__trigger')
    const tableContainer = container.querySelector('.rate-table__table')

    btn.addEventListener('click', () => {
      btn.classList.toggle('open')
      tableContainer.classList.toggle('open')
    })
  },
})
